define(
({
  "select_shipping_method": "Выбрать способ доставки"
})
);
